import React, { PureComponent, Fragment } from "react";
import { PropTypes } from "prop-types";
import { Dropdown, Icon } from "semantic-ui-react";

class ConnectionDropdownMenu extends PureComponent {
  static propTypes = {
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onReset: PropTypes.func,
    deleting: PropTypes.bool,
    editing: PropTypes.bool,
    disabled: PropTypes.bool,
    copy: PropTypes.object.isRequired
  };

  // -- RENDER -- //

  renderItems = () => {
    const { deleting, editing, onEdit, onDelete, onReset, copy } = this.props;

    if ((deleting || editing) && onReset) {
      return (
        <Dropdown.Item onClick={onReset}>
          <Icon name="redo alternate" />
          {copy.reset}
        </Dropdown.Item>
      );
    }

    return (
      <Fragment>
        {onEdit && (
          <Dropdown.Item onClick={onEdit}>
            <Icon name="edit" />
            {copy.edit}
          </Dropdown.Item>
        )}
        {onDelete && (
          <Dropdown.Item onClick={onDelete}>
            <Icon name="trash" />
            {copy.delete}
          </Dropdown.Item>
        )}
      </Fragment>
    );
  };

  render() {
    const { disabled } = this.props;

    return (
      <Dropdown
        closeOnChange={false}
        icon="sidebar"
        direction="left"
        pointing="right"
        className="float-right"
        disabled={disabled}
      >
        <Dropdown.Menu className="project-dropdown-menu">
          {this.renderItems()}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default ConnectionDropdownMenu;
